import { render, staticRenderFns } from "./NewFeaturesAnnouncement.vue?vue&type=template&id=5e9a1b5e"
import script from "./NewFeaturesAnnouncement.vue?vue&type=script&lang=js"
export * from "./NewFeaturesAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports